var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',_vm._b({staticClass:"collapse-toggle",class:{'collapsed': _vm.isCollapsed },attrs:{"icon":""},on:{"click":_vm.toggleSideMenuCollapse}},'v-btn',_vm.$props,false),[_c('inline-svg',{staticClass:"icon",attrs:{"width":"24px","height":"24px","src":_vm.icon}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }